<div class="edit-toggle-page">
	<div class="content-container column">
		<div class="content-container-header flex-row flex-wrap">
			<h3 class="flex-grow header-h3" i18n="@@clientDetails-title">Client Details</h3>

			@if (canEditPublicInfo) {
				@if (!editingPublicInfo) {
					<div>
						<button
							mat-button
							i18n="@@clientDetails-edit"
							class="primary-button"
							data-automation-id="contact-list-edit-button"
							(click)="editPublicInfoButtonClicked()"
						>
							Edit
						</button>
					</div>
				} @else {
					<div>
						<button
							mat-button
							class="secondary-button"
							i18n="@@clientDetails-detailCancel"
							data-automation-id="client-details-cancel-button"
							(click)="editPublicInfoCancelButtonClicked()"
						>
							Cancel
						</button>
						<button
							mat-button
							class="primary-button"
							i18N="@@clientDetails-detailSave"
							data-automation-id="client-details-save-button"
							[disabled]="
								firstname.invalid ||
								lastname.invalid ||
								idn.invalid ||
								(client.active === (status.value === 'active') &&
									client.firstName === firstname.value &&
									client.lastName === lastname.value &&
									client.idn === idn.value)
							"
							(click)="savePublicInfoEdits()"
						>
							Save
						</button>
					</div>
				}
			}
		</div>

		<mat-divider></mat-divider>

		<div class="content-container-body column spacing-24">
			@if (!editingPublicInfo) {
				<div class="row bottom-padding">
					<table style="width: 50%">
						<tr class="mat-body-2">
							<td class="width-25-grey-no-bold" i18n="@@clientDetails-status">Status</td>
							<td class="width-25-grey-no-bold" i18n="@@clientDetails-property">Property</td>
							<td class="width-25-grey-no-bold" i18n="@@clientDetails-deviceSerialNumber">Device Serial Number</td>
						</tr>
						<tr class="mat-body-3">
							<td class="table-body-text padding-for-td">
								<mat-chip-set>
									<mat-chip class="status-chip" [ngClass]="getChipStyling(client.active)"
										>&bull;&NonBreakingSpace;{{ client.active ? 'Active' : 'Inactive' }}</mat-chip
									>
								</mat-chip-set>
							</td>
							<td class="table-body-text padding-for-td">{{ client.property?.name ?? '' }}</td>
							<td class="table-body-text padding-for-td">{{ client.serialNumber ?? '' }}</td>
						</tr>
					</table>
				</div>
				<div class="row bottom-padding">
					<table style="width: 50%">
						<tr class="mat-body-2">
							<td class="width-25-grey-no-bold" i18n="@@clientDetails-firstName">First Name</td>
							<td class="width-25-grey-no-bold" i18n="@@clientDetails-lastName">Last Name</td>
							<td class="width-25-grey-no-bold" i18n="@@clientDetails-clientIdn">Client IDN</td>
						</tr>
						<tr class="mat-body-3">
							<td class="table-body-text padding-for-td">{{ client.firstName }}</td>
							<td class="table-body-text padding-for-td">{{ client.lastName }}</td>
							<td class="table-body-text padding-for-td">{{ client.idn }}</td>
						</tr>
					</table>
				</div>
			} @else {
				<div class="row bottom-padding">
					<table style="width: 50%">
						<tr class="mat-body-2">
							<td class="width-25-grey-no-bold" i18n="@@clientDetails-status">Status</td>
							<td class="width-25-grey-no-bold" i18n="@@clientDetails-property">Property</td>
							<td class="width-25-grey-no-bold" i18n="@@clientDetails-deviceSerialNumber">Device Serial Number</td>
						</tr>
						<tr class="mat-body-3">
							<td class="table-body-text padding-for-td">
								<mat-form-field subscriptSizing="dynamic" appearance="outline">
									<mat-select [formControl]="status" data-automation-id="status-picker">
										<mat-option value="active">Active</mat-option>
										<mat-option value="inactive">Inactive</mat-option>
									</mat-select>
								</mat-form-field>
							</td>
							<td class="table-body-text padding-for-td">
								{{ client.property?.name ?? '' }}
							</td>
							<td class="table-body-text padding-for-td">
								{{ client.serialNumber ?? '' }}
							</td>
						</tr>
					</table>
				</div>
				<div class="row bottom-padding">
					<table style="width: 50%">
						<tr class="mat-body-2">
							<td class="width-25-grey-no-bold" i18n="@@clientDetails-firstName">First Name</td>
							<td class="width-25-grey-no-bold" i18n="@@clientDetails-lastName">Last Name</td>
							<td class="width-25-grey-no-bold" i18n="@@clientDetails-clientIdn">Client IDN</td>
						</tr>
						<tr class="mat-body-3">
							<td class="table-body-text padding-for-td">
								<mat-form-field subscriptSizing="dynamic" appearance="outline">
									<input matInput [formControl]="firstname" data-automation-id="first-name-input" />
								</mat-form-field>
							</td>
							<td class="table-body-text padding-for-td">
								<mat-form-field subscriptSizing="dynamic" appearance="outline">
									<input matInput [formControl]="lastname" data-automation-id="last-name-input" />
								</mat-form-field>
							</td>
							<td class="table-body-text padding-for-td">
								<mat-form-field subscriptSizing="dynamic" appearance="outline">
									<input matInput [formControl]="idn" data-automation-id="client-idn-input" />
								</mat-form-field>
							</td>
						</tr>
					</table>
				</div>
			}
		</div>
	</div>

	<!--* Load the List of contacts for the notification : -->
	@if (contactNotificationsEnabled) {
		<app-contacts-of-notification-main
			[clientId]="clientId"
			[canEdit]="canEditPublicInfo"
		></app-contacts-of-notification-main>
	}
</div>
